import {GetLostFindTypeList, GetLostFindList, GetLostFindDetail,PostClaimThing, PostConfirmThing, GetMineLostFindList, DeleteLostFoundItem, GetSchoolList, GetTabList, PostLostFoundImage, PostLostFound, GetLostFoundRecommend,PutLostFound, GetCheckNumber, PostFound, GetGuideStatus, PostGuideStatus} from '@/api/LostFind'


const LostFind = {
  actions: {
    getLostFindTypeList({commit},params){
      return new Promise((resolve, reject) => {
        GetLostFindTypeList(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLostFindList({commit},params){
      return new Promise((resolve, reject) => {
        GetLostFindList(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLostFindDetail({commit},params){
      return new Promise((resolve, reject) => {
        GetLostFindDetail(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    postClaimThing({commit},params){
      return new Promise((resolve, reject) => {
        PostClaimThing(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    postConfirmThing({commit},params){
      return new Promise((resolve, reject) => {
        PostConfirmThing(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getMineLostFindList({commit},params){
      return new Promise((resolve, reject) => {
        GetMineLostFindList(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    deleteLostFoundItem({commit},params){
      return new Promise((resolve, reject) => {
        DeleteLostFoundItem(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getSchoolList({commit},params){
      return new Promise((resolve, reject) => {
        GetSchoolList(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getTabList({commit},params){
      return new Promise((resolve, reject) => {
        GetTabList(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    postLostFoundImage({commit},params){
      return new Promise((resolve, reject) => {
        PostLostFoundImage(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    postLostFound({commit},params){
      return new Promise((resolve, reject) => {
        PostLostFound(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLostFoundRecommend({commit},params){
      return new Promise((resolve, reject) => {
        GetLostFoundRecommend(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    putLostFound({commit},params){
      return new Promise((resolve, reject) => {
        PutLostFound(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCheckNumber({commit},params){
      return new Promise((resolve, reject) => {
        GetCheckNumber(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    postFound({commit},params){
      return new Promise((resolve, reject) => {
        PostFound(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getGuideStatus({commit},params){
      return new Promise((resolve, reject) => {
        GetGuideStatus(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    postGuideStatus({commit},params){
      return new Promise((resolve, reject) => {
        PostGuideStatus(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default LostFind


// WEBPACK FOOTER //
// ./src/store/modules/LostFind.js


// WEBPACK FOOTER //
// ./src/store/modules/LostFind.js